import { useQuery } from "@tanstack/react-query";
import { RequestOrderFormSelectedOptions } from "hooks/api/requestOrder";
import useSelectedContractDocEntry from "hooks/useSelectedContractDocEntry";
import {
  getContractOrderRequestQueryOptions,
  mapDimCodeNameToSelectOption,
} from "./getContractOrderRequestQueryOptions";

const useGetContractOrderRequestShipFroms = ({
  shipTo,
  shipFrom,
  salesTerms,
  mode,
}: RequestOrderFormSelectedOptions) => {
  const selectedContractDocEntry = useSelectedContractDocEntry();
  return useQuery({
    ...getContractOrderRequestQueryOptions(selectedContractDocEntry, {
      modeOfTransportationCode: mode?.value,
      salesTermsCode: salesTerms?.value,
      shipToCode: shipTo?.value,
    }),
    enabled: !!selectedContractDocEntry && !shipFrom,
    keepPreviousData: !!shipFrom,
    select: ({ data }) =>
      data?.ShipFromWarehouses?.map(mapDimCodeNameToSelectOption),
  });
};

export default useGetContractOrderRequestShipFroms;
